<template>
    <div class="city-content">
        <div class="count border-box">
            <div>开单量：累计/今日</div>
            <div class="count-text">
                <span>{{ totalCount }} / </span>
                <span style="color: #80FFFF;">{{ dayCount }}</span>
            </div>
        </div>
        <div class="money border-box">
            <div>开单金额：累计/今日</div>
            <div class="count-text">
                <span>{{ totalCount * product }} / </span>
                <span style="color: #80FFFF;">{{ dayCount * product }}</span>
            </div>
        </div>
    </div>
</template>
<script>
import { getSettlementOrderStatistics } from '../../api/holdMy.js';
export default {

    data() {
        return {
            refreshImgIng: null,   // 刷新定时器
            totalCount: 0,
            dayCount: 0,
            getData: {
                cityName: this.$route.query.cityName,
                city: this.$route.query.cityName,
            },
            // 默认 386
            cityList: [{
                cityName: '厦门',
                product: 386,
            }, {
                cityName: '南昌',
                product: 388,
            }, {
                cityName: '广州',
                product: 518,
            }],
            product: 386,
        }
    },
    components: {},
    created() {
        this.getProduct();
        this.$store.watch(
            state => state.orderCount,
            (newValue, oldValue) => {
                console.log('myData 发生变化：', oldValue, '->', newValue);
                // 在这里执行你的逻辑，更新页面 B 中的数据
                this.dayCount = newValue
            }
        );
    },
    mounted() {
        this.refreshScale();
    },

    beforeDestroy() {
        clearInterval(this.refreshImgIng);
    },
    methods: {
        // 获取车辆单价
        getProduct() {
            for (let key in this.cityList) {
                if (this.cityList[key].cityName === this.getData.city) {
                    this.product = this.cityList[key].product
                }
            }
        },
        // 刷新数据
        refreshScale() {
            this.getSettlementOrderStatistics()
            this.refreshImgIng = setInterval(() => {
                this.getSettlementOrderStatistics()
            }, 1000 * 30)
        },
        // 获取订单New
        getSettlementOrderStatistics() {
            getSettlementOrderStatistics({ ...this.getData }).then(res => {
                if (res.result == 0) {
                    // this.dayCount = res.userdata.dayCount || 0;
                    this.totalCount = res.userdata.totalCount || 0;
                }
            }).catch(error => {
                console.log(error);
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.city-content {
    height: 100px;
    align-items: center;

    .border-box {
        height: 100%;
        background: inherit;
        background-color: rgba(0, 0, 0, 0.2);
        box-sizing: border-box;
        border-width: 1px;
        border-style: solid;
        border-color: rgba(71, 179, 254, 1);
        border-radius: 15px;
        border-top-left-radius: 0px;
        border-bottom-right-radius: 0px;
        font-family: 'Microsoft YaHei', sans-serif;
        color: #FFF000;
        font-size: 16px;
        padding: 12px 0px 0px 40px;
    }

    .count {
        width: 38%;
        float: left;
    }

    .money {
        width: 60%;
        float: right;
    }

    .count-text {
        font-family: 'Impact Normal', 'Impact', sans-serif;
        font-weight: 400;
        font-style: normal;
        font-size: 34px;
        color: #FFFFFF;
        margin-top: 20px;
        margin-left: 15px;
    }
}
</style>